import TokensModel from './tokensModel';

const localStorageKey = 'oauth';

class TokensStorage {
    store(tokensModel) {
        localStorage.setItem(localStorageKey, tokensModel.toString());
    }

    get() {
        const str = localStorage.getItem(localStorageKey);

        if (!str) {
            return null;
        }

        return TokensModel.fromString(str);
    }

    remove() {
        localStorage.removeItem(localStorageKey);
    }
}

export default new TokensStorage();
